import * as React from 'react';
import PropTypes from 'prop-types';
import { Form, connectField, connectSubmit } from 'onion-form';
import { Alert, Grid, Well } from 'react-bootstrap';
import { connect } from 'react-redux';

import * as validators from '../../../common/validators';
import BasicFormField from '../components/basic_form_field';

import { submitForm } from './actions';

const Email = connectField('email', { type: 'email' })(BasicFormField);
const Password = connectField('password', { type: 'password' })(BasicFormField);
const Submit = connectSubmit(props => <button {...props}>{props.children}</button>);

@connect(({ login: { errored } }) => ({ errored }), { submitForm })
export default class Login extends React.Component {
  static propTypes = {
    errored: PropTypes.bool.isRequired,
    submitForm: PropTypes.func.isRequired
  };

  render() {
    const { errored, submitForm } = this.props;

    return (
      <Grid>
        <Well>
          { errored &&
            <Alert bsStyle="danger">Přihlášení se nezdařilo.</Alert>
          }
          <h2>Přihlášení</h2>
          <Form
            onSubmit={submitForm}
            name="signIn"
          >
            <Email label="Email:" validations={[validators.isEmail]} />
            <Password label="Heslo:" />
            <Submit className="btn btn-primary">Přihlásit se</Submit>
          </Form>
        </Well>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/login/index.jsx